import { configureStore } from '@reduxjs/toolkit';
import gameReducer from '../components/game/gameSlice';
import dashboardReducer from '../components/dashboard/dashboardSlice';

export default configureStore({
  reducer: {
    game:gameReducer,
    dashboard: dashboardReducer
  },
});